<template>
    <tr>
        <td>{{ driver_commission.staff.name}}</td>
        <td>
            <router-link
                v-if="driver_commission.core_waybill"
                :to="{
                    name: 'edit_core_waybill',
                    params: {identity: driver_commission.core_waybill.identity}
                }">
                {{ driver_commission.core_waybill.number }}
            </router-link>
            <span v-else>
                -
            </span>
        </td>
        <td>
            <span v-if="driver_commission.driver_commission_report_identity">
                <i class="minus icon" v-if="driver_commission.polarity == false"></i>
                {{ driver_commission.amount }}
            </span>
            <span v-else>
                <!-- 尚未結算 -->
                {{ $t('ui.pages.driver_commissions.no_done') }}
            </span>
        </td>
        <td>
            {{ this.human_datetime(driver_commission.created_at) }}
        </td>
    </tr>
</template>

<script>
export default {
    name: "ProviderDriverCommissionsIndexItem",
    props: {
        driver_commission: Object
    },
    data() {
        return {
        }
    },
    computed: {
    },
    mounted() {
    },
    methods: {
    },

}
</script>

<style scoped lang="scss">
</style>
